import request from "@/utils/request";

const update = (params) => request
  .put(`/api/library/${params.bookId}`, {
    body: {
      meta_data: { // eslint-disable-line camelcase
        current_chapter_id: params.currentChapterId, // eslint-disable-line camelcase
        last_chapter_id: params.currentChapterId, // eslint-disable-line camelcase
        blinksPackId: params.bookId,
        is_finished: params.isFinished // eslint-disable-line camelcase
      }
    },
    token: true
  });

export default {
  update
};
